import axiosInstance from './apiConfig';

const BASE_URL = '/subProperty';

export const addNewSubProperty = async (data: any) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}/add`, data);
    return response.data;
  } catch (error: any) {
    throw new Error(`add sub property failed ${error.response?.data?.error}`);
  }
};

export const getAllSubProperties = async (search?: string) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/getAll`, {
      params: {
        ...(search ? { search } : {}),
      },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      `Failed to fetch sub properties ${error.response?.data?.error}`,
    );
  }
};

export const getSubPropertyById = async (id: string) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/getById`, {
      params: { id },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      `fetch sub property by id failed ${error.response?.data?.error}`,
    );
  }
};

export const updateSubProperty = async (id: number, data: any) => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/update`, data, {
      params: { id },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      `update sub property failed ${error.response?.data?.error}`,
    );
  }
};

export const deleteSubProperty = async (id: string) => {
  try {
    const response = await axiosInstance.delete(`${BASE_URL}/delete`, {
      params: { id },
    });
    return response.data;
  } catch (error: any) {
    throw error?.response?.data || error;
  }
};

export const getSubPropertiesByPropertyId = async (
  propertyId: string,
  search?: string,
) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/getByPropertyId`, {
      params: {
        propertyId,
        ...(search ? { search } : {}),
      },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      `Failed to fetch sub properties ${error.response?.data?.error}`,
    );
  }
};

// ---- Sub Property History ----
const HISTORY_BASE_URL = '/subPropertyRentHistory';

export const addSubPropertyHistory = async (data: any) => {
  try {
    const res = await axiosInstance.post(`${HISTORY_BASE_URL}/add`, data);
    return res.data;
  } catch (error: any) {
    throw new Error(`add history failed ${error.response?.data?.error}`);
  }
};

export const updateSubPropertyHistory = async (id: number, data: any) => {
  try {
    const res = await axiosInstance.put(`${HISTORY_BASE_URL}/update`, data, {
      params: { id },
    });
    return res.data;
  } catch (error: any) {
    throw new Error(`update history failed ${error.response?.data?.error}`);
  }
};

export const deleteSubPropertyHistory = async (id: string) => {
  try {
    const res = await axiosInstance.delete(`${HISTORY_BASE_URL}/delete`, {
      params: { id },
    });
    return res.data;
  } catch (error: any) {
    throw new Error(`delete history failed ${error.response?.data?.error}`);
  }
};

export const getHistoryBySubPropertyId = async (subPropertyId: string) => {
  try {
    const res = await axiosInstance.get(
      `${HISTORY_BASE_URL}/getBySubPropertyId`,
      {
        params: { subPropertyId },
      },
    );
    return res.data;
  } catch (error: any) {
    throw new Error(`fetch history failed ${error.response?.data?.error}`);
  }
};

export const exportSubProperties = async (
  propertyId?: number,
): Promise<Blob> => {
  try {
    let url = `${BASE_URL}/export`;

    if (propertyId) {
      url += `?propertyId=${propertyId}`;
    }

    const response = await axiosInstance.get(url, {
      responseType: 'blob',
    });

    return response.data;
  } catch (error: any) {
    throw new Error(
      `export sub properties failed ${error.response?.data?.error || error}`,
    );
  }
};

export const uploadSubProperties = async (file: File) => {
  const data = new FormData();
  data.append('file', file);

  try {
    const response = await axiosInstance.post(`${BASE_URL}/upload`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error: any) {
    throw error?.response?.data || error;
  }
};
